import Url from "../../../url/Url";
import IncreaseVolIcon from "../Icons/IncreaseVolIcon";
import DecreaseVolIcon from "../Icons/DecreaseVolIcon";
import ImageWithLoader from "../../../components/imageLoader/ImageWithLoader";
import {PiCoinsLight} from "react-icons/pi";

export default function CardSymbol({ onClick, s }) {
  // Safely parse the change value
  const changeValue = parseFloat(s?.open ?? s?.change ?? s?.changePercent ?? 0);
  const isPositive = changeValue > 0;

  // Format percentage safely
  const percentage = isNaN(changeValue) ? 0 : changeValue / 100;
  console.log(s)

    const formatNumber = (value) => {
        const number = Number(value);

        if (isNaN(number)) return "0.00";

        return number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

  return (
    <div
      onClick={onClick}
      key={s?._id || s?.symbol}
      className="symbol-card bg-white p-5 rounded-2xl cursor-pointer shadow-md hover:shadow-lg transition-shadow duration-200"
    >
      <div className="flex items-center space-x-3 mb-4">
        <div className="min-w-12 min-h-12 max-w-12 max-h-12 rounded-xl shadow-sm overflow-hidden">
          {s?.image?.path ? (
            <ImageWithLoader src={`${Url}${s.image.path}`} alt={s?.symbol} />
          ) : (
              <div className="flex justify-center items-center w-12 h-12 rounded-xl bg-gray-100" >
                  <PiCoinsLight className="w-7 h-7 text-gray-400"/>
              </div>
          )}
        </div>

        <div>
          <div className="font-bold text-text-primary">{s?.symbol}</div>
          <div className="text-xs text-text-secondary">{s?.name}</div>
        </div>
      </div>

      <div className="text-xl font-bold text-text-primary mb-2">
          ${formatNumber(s?.volume ?? s?.price ?? 0)}
      </div>

      <div className="flex items-center space-x-2">
        <div
          className={`flex items-center space-x-1 min-w-[80px] flex-row justify-center 
            ${isPositive ? "bg-green-100" : "bg-red-100"} 
            px-2 py-1 rounded-lg`}
        >
          {isPositive ? (
            <i className="w-[10px] text-xs text-green-700">
              <IncreaseVolIcon />
            </i>
          ) : (
            <i className="w-[10px] text-xs text-red-700">
              <DecreaseVolIcon />
            </i>
          )}

          <p
            className={`text-sm font-semibold text-center ${
              isPositive ? "text-green-700" : "text-red-700"
            }`}
          >
            {percentage.toFixed(2)}%
          </p>
        </div>
      </div>
    </div>
  );
}
